import axios from 'axios';
import API_URL from '@/constants/API_URL';
import API_V2_URL from '@/constants/API_V2_URL';

const EmployeeService = {
  all({ page, limit, q, status }) {
    return axios.get(`${API_V2_URL()}/system/employees?page=${page}&status=${status}&limit=${limit}&q=${q}`);
  },
  create(formData) {
    return axios.post(`${API_V2_URL()}/system/employees`, formData);
  },
  update(formData, id) {
    return axios.put(`${API_V2_URL()}/system/employees/${id}`, formData);
  },
  getEmployee(id) {
    return axios.get(`${API_URL()}/users/${id}`);
  },
};

export default EmployeeService;



// WEBPACK FOOTER //
// ./src/services/system/EmployeeService.js